function header_transition() {
    document.addEventListener('DOMContentLoaded', function() {
        const headerElement = document.querySelector('header');
        const firstSection = document.querySelector('.hero-banner-wrapper');
        const logoElement = document.getElementById('logo-marca');
        if (window.location.pathname === '/' || window.location.pathname === '/index.html') {
            if (headerElement) {
                const scrollThreshold = firstSection.offsetHeight;
                window.addEventListener('scroll', function() {
                    if (window.scrollY > scrollThreshold) {
                        headerElement.classList.add('header_transition');
                        logoElement.src = 'img/arctic-hunter/menu_sticky_logo_arctichunter_color.svg';
                    } else {
                        headerElement.classList.remove('header_transition');
                        logoElement.src = 'img/arctic-hunter/head_home_arctic_hunter_white_logo.svg';
                    }
                });
            }
        } else {
            headerElement.classList.add('header_other_pages');
        }
    });
}

function whatsapp_icon_productsPage() {
    document.addEventListener('DOMContentLoaded', function() {
        const whatsappIcon = document.getElementById('whatsapp--icon');
        if (window.location.pathname.startsWith('/products/')) {
            whatsappIcon.classList.add("products");
        }
    
    });
}

function show_product__header() {
    document.addEventListener('DOMContentLoaded', function() {
    const productHeader = document.getElementById('product__header');
    if (!productHeader) return; 
    const scrollThreshold = 200;
    function updateHeaderVisibility() {
        const isScrolledDown = window.scrollY >= scrollThreshold;
        if (isScrolledDown) {
            productHeader.classList.remove('header__bottom__hidden');
            productHeader.classList.add('header__bottom');
        } else {
            productHeader.classList.remove('header__bottom');
            productHeader.classList.add('header__bottom__hidden');
        }
    }
    window.addEventListener('scroll', updateHeaderVisibility);
    Livewire.hook('element.updated', (el, component) => {
    updateHeaderVisibility();
    });
    updateHeaderVisibility();
    
    });
}

function header_input_active() {
    const header_input = document.querySelector('.header__input');
    const header_input_icon = document.querySelector('.header__input__icon');

    if (header_input && header_input_icon) {
        header_input_icon.addEventListener('click', (event) => {
            event.stopPropagation();
            header_input.classList.add('active');
            header_input.focus();
        });


        document.addEventListener('click', (event) => {

            if (header_input.classList.contains('active') &&
                !header_input.contains(event.target) &&
                !header_input_icon.contains(event.target)) {
                header_input.classList.remove('active');
            }
        });
    }
}

function responsiveMenu() {
    const btnMobile = document.getElementById("btn-mobile");
    const btnAnchor = document.getElementsByClassName("content__item");
    let countBtnAnchor = btnAnchor.length;

    function toggleMenu(event) {
        if (event.type === "touchstart") event.preventDefault();
        const nav = document.getElementById("nav");
        const active = nav.classList.contains("active");

        nav.classList.toggle("active");
        event.currentTarget.setAttribute("aria-expanded", active);

        if (active) {
            event.currentTarget.setAttribute("aria-label", "Close menu");
        } else {
            event.currentTarget.setAttribute("aria-label", "Open Menu");
        }
    }

    if (btnMobile) {
        btnMobile.addEventListener("click", toggleMenu);
        btnMobile.addEventListener("touchstart", toggleMenu);
    }

    // for (let i = 0; i < countBtnAnchor; i++) {
    //     btnAnchor[i].addEventListener("click", toggleMenu);
    // }
}


function asideBagMenu() {
    const bagMenu = document.querySelector(".header__bag");
    const closeAsideMenu = document.querySelector(".menu-bag__close");
    const btnCloseAsideMenu = document.querySelector("#btnCloseAsideMenu");

    if (bagMenu) {
        bagMenu.addEventListener("click", () => {
            Livewire.emit("openModalCart", "toggle");
        });

        closeAsideMenu.addEventListener("click", () => {
            Livewire.emit("openModalCart", false);
        });

        btnCloseAsideMenu.addEventListener("click", () => {
            Livewire.emit("openModalCart", false);
        });
    }
}

function asideFilterMenu() {
    const filterBtn = document.querySelector(".products__filter");
    const filterMenu = document.querySelector(".products-aside__wrapper");
    const closeFilterMenu = document.querySelector(".products-aside__close");

    if (filterBtn) {
        filterBtn.addEventListener("click", (e) => {
            e.preventDefault();
            filterMenu.classList.toggle("active");

            closeFilterMenu.addEventListener("click", () => {
                filterMenu.classList.remove("active");
            });
        });
    }
}

function productAttribute() {
    const attributeName = document.querySelectorAll(
        ".product__attribute__name",
    );
    const productOptions = document.querySelectorAll(
        ".product__attribute__list",
    );

    attributeName.forEach((item, index) => {
        item.addEventListener("click", () => {
            item.classList.toggle("active");
            productOptions[index].classList.toggle("active");
        });
    });
}

function jqueryMasks() {
    $(document).ready(function () {
        var SPMaskBehavior = function (val) {
                return val.replace(/\D/g, "").length === 11
                    ? "(00) 00000-0000"
                    : "(00) 0000-00009";
            },
            spOptions = {
                onKeyPress: function (val, e, field, options) {
                    field.mask(SPMaskBehavior.apply({}, arguments), options);
                },
            };
        if ($().mask) {
            $(".cep").mask("00000-000");
            $(".phone_with_ddd").mask(SPMaskBehavior, spOptions);
            $(".telephone").mask("(00) 0000-0000");
            $(".credit-card").mask("0000 0000 0000 0000");
            $(".cpf").mask("000.000.000-00");
            $(".cnpj").mask("00.000.000/0000-00");
            $(".money").mask("000.000.000.000.000,00", { reverse: true });
            $(".money2").mask("#.##0,00", { reverse: true });
        }
    });
}

function toggleOrderInformation() {
    const productOrder = document.querySelectorAll(".order-in-shipping");
    const productOrderToggle = document.querySelectorAll(".toggle-order");

    productOrderToggle.forEach((item, index) => {
        item.addEventListener("click", (e) => {
            e.preventDefault();
            productOrder[index].classList.toggle("active");
        });
    });
}

function togglePasswordVisibility() {
    const togglePassword = document.querySelectorAll(".show-password");

    togglePassword.forEach((item) => {
        item.addEventListener("click", (e) => {
            e.preventDefault();

            let inputPassword = document.querySelectorAll(".password");

            inputPassword.forEach((item) => {
                if (item.type === "password") {
                    item.type = "text";
                } else {
                    item.type = "password";
                }
            });
        });
    });
}

function benefitsCarousel() {
    var swiper = new Swiper(".benefitsSwiper", {
        slidesPerView: 2,
        spaceBetween: 30,
        disabled: false,
        loop: true,
        speed: 3000,
        autoplay: {
            delay: 0,
        },
        breakpoints: {
            768: {
                slidesPerView: 3,
                disabled: false,
                speed: 4000,
                autoplay: {
                    delay: 0,
                },
            },
            1280: {
                slidesPerView: 5,
                disabled: false,
                speed: 5000,
                autoplay: {
                    delay: 0,
                },
            },
            1920: {
                slidesPerView: 7,
                spaceBetween: 30,
                enabled: false,
                autoplay: {
                    enabled: false,
                },
            },
        },
    });
}

function bannerCarousel() {
    var swiper = new Swiper(".bannerSwiper", {
        loop: false,
        autoplay: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
        },
    });
}


function categoryCarousel() {
    var swiper = new Swiper(".categorySwiper", {
        slidesPerView: 1,
        spaceBetween: 30,
        centerInsufficientSlides: true,
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 4,
            },
            1140: {
                slidesPerView: 5,
            },
            1440: {
                slidesPerView: 6,
            },
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
}

function productCarousel() {
    var swiperProductThumb = new Swiper(".productThumbSwiper", {
        loop: false,
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
    });
    var swiperProduct = new Swiper(".productSwiper", {
        loop: true,
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: swiperProductThumb,
        },
    });
}


function removeProductModal() {
    document.addEventListener("confirmRemoveProduct", () => {
        $("#removeItemModal").modal("show");
    });
}

function previewLoadImage() {
    const chooseFile = document.querySelectorAll(".choose-file");
    const imgPreview = document.querySelectorAll(".img-preview");
    const imgAlreadyPreview = document.querySelectorAll(".img-already-preview");
    const imgThumbAlreadyPreview = document.querySelectorAll(
        ".img-thumb-already-preview",
    );
    const imgPreviewThumb = document.querySelectorAll(".choose-file-label");
    const productCarousel = document.querySelector(".add-product");
    const removeImg = imgPreviewThumb ? imgPreviewThumb.parentNode : null;
    const removeImgThumb = imgThumbAlreadyPreview
        ? imgThumbAlreadyPreview.parentNode
        : null;

    chooseFile.forEach((file, index) => {
        file.addEventListener("change", () => {
            getImgData(file, index);
        });
    });

    function getImgData(file, index) {
        const files = file.files[0];
        if (files) {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(files);
            fileReader.addEventListener("load", function () {
                if (removeImg) {
                    removeImg.removeChild(imgAlreadyPreview);
                }
                if (removeImgThumb) {
                    removeImgThumb.removeChild(imgThumbAlreadyPreview);
                }
                imgPreview[index].style.display = "block";
                imgPreview[index].innerHTML =
                    '<img src="' + this.result + '" />';
                imgPreview[index].style.border = "none";
                if (imgPreviewThumb[index]) {
                    imgPreviewThumb[index].style.display = "block";
                    imgPreviewThumb[index].innerHTML =
                        '<img src="' + this.result + '" />';
                }
                chooseFile[index].parentNode.style.border = "none";

                if (productCarousel)
                    productCarousel.classList.add("image-uploaded");
            });
        }
    }
}

document.addEventListener("updateCarousel", () => {
    productCarousel();
});

header_input_active();
header_transition();
responsiveMenu();
asideBagMenu();
asideFilterMenu();
productAttribute();
jqueryMasks();
toggleOrderInformation();
togglePasswordVisibility();
benefitsCarousel();
bannerCarousel();
categoryCarousel();
productCarousel();
removeProductModal();
previewLoadImage();
show_product__header();
whatsapp_icon_productsPage();